import React, { useState } from 'react';
import { donateTiers, upiInfo, cryptoWallets } from '../mock';
import { Coffee, Heart, Check, Copy, RotateCcw, MessageSquare, Bitcoin, Instagram } from 'lucide-react';

export default function DonateSection() {
  const [selected, setSelected] = useState('d-02');
  const [custom, setCustom] = useState('');
  const [thanks, setThanks] = useState(false);
  const [tab, setTab] = useState('upi'); // 'upi' | 'message' | 'crypto'
  const [flipped, setFlipped] = useState(false);
  const [copiedAddr, setCopiedAddr] = useState(null);

  const confirm = () => {
    setThanks(true);
    setTimeout(() => setThanks(false), 2800);
  };

  const goContact = () => {
    const el = document.getElementById('contact');
    if (el) window.scrollTo({ top: el.offsetTop - 40, behavior: 'smooth' });
  };

  const copyAddr = (addr, id) => {
    navigator.clipboard.writeText(addr);
    setCopiedAddr(id);
    setTimeout(() => setCopiedAddr(null), 1400);
  };

  const tabs = [
    { id: 'upi', label: 'UPI / QR' },
    { id: 'message', label: 'Message + tip' },
    { id: 'crypto', label: 'Crypto' },
  ];

  return (
    <section id="donate" className="section" style={{ paddingBottom: 80 }}>
      <div className="reveal" style={{ marginBottom: 48 }}>
        <div className="section-label" style={{ marginBottom: 16 }}>
          08 &mdash; Donate
        </div>
        <h2 className="section-title" style={{ margin: 0, maxWidth: 760 }}>
          Fuel the<br />
          <span style={{ color: 'rgba(245,245,245,0.45)' }}>late-night renders.</span>
        </h2>
        <p
          style={{
            marginTop: 20,
            color: 'rgba(245,245,245,0.6)',
            fontSize: 15,
            lineHeight: 1.7,
            maxWidth: 560,
          }}
        >
          No pressure at all &mdash; but if something here helped you, a small tip
          keeps the caffeine flowing and the projects shipping. Pick any method you trust.
        </p>
      </div>

      <div className="glass-card reveal" style={{ padding: 36 }}>
        {/* Tab switcher */}
        <div
          className="donate-tabs"
          style={{
            display: 'inline-flex',
            gap: 4,
            padding: 4,
            borderRadius: 999,
            background: 'rgba(245,245,245,0.04)',
            border: '1px solid rgba(245,245,245,0.08)',
            marginBottom: 32,
          }}
        >
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              style={{
                padding: '10px 18px',
                borderRadius: 999,
                border: 'none',
                background: tab === t.id ? '#f5f5f5' : 'transparent',
                color: tab === t.id ? '#000' : 'rgba(245,245,245,0.7)',
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: 11,
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'background 200ms ease, color 200ms ease',
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        {tab === 'upi' && (
          <div className="twocol" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1.2fr) minmax(0, 1fr)', gap: 48 }}>
            <div>
              <div
                className="mono"
                style={{
                  fontSize: 10,
                  letterSpacing: '0.35em',
                  color: 'rgba(245,245,245,0.45)',
                  textTransform: 'uppercase',
                  marginBottom: 20,
                }}
              >
                / Choose an amount
              </div>

              <div className="tier-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
                {donateTiers.map((t) => {
                  const isSel = selected === t.id;
                  return (
                    <button
                      key={t.id}
                      onClick={() => setSelected(t.id)}
                      style={{
                        padding: '20px 20px',
                        border: `1px solid ${isSel ? '#f5f5f5' : 'rgba(245,245,245,0.12)'}`,
                        background: isSel ? 'rgba(245,245,245,0.06)' : 'transparent',
                        borderRadius: 10,
                        textAlign: 'left',
                        cursor: 'pointer',
                        color: '#f5f5f5',
                        transition: 'border-color 200ms ease, background 200ms ease, transform 200ms ease',
                        transform: isSel ? 'translateY(-2px)' : 'translateY(0)',
                      }}
                    >
                      <div className="mono" style={{ fontSize: 10, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.5)', textTransform: 'uppercase' }}>
                        {t.label}
                      </div>
                      <div style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 28, fontWeight: 600, marginTop: 4 }}>
                        {t.amount ? `₹${t.amount}` : 'Custom'}
                      </div>
                      <div style={{ color: 'rgba(245,245,245,0.55)', fontSize: 12, marginTop: 4 }}>
                        {t.note}
                      </div>
                    </button>
                  );
                })}
              </div>

              {selected === 'd-04' && (
                <div style={{ marginTop: 16 }}>
                  <span className="mono" style={{ fontSize: 10, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.6)' }}>
                    CUSTOM AMOUNT (₹)
                  </span>
                  <input
                    type="number"
                    value={custom}
                    onChange={(e) => setCustom(e.target.value)}
                    placeholder="Enter amount"
                    style={{
                      width: '100%',
                      background: 'transparent',
                      border: 'none',
                      borderBottom: '1px solid rgba(245,245,245,0.2)',
                      color: '#f5f5f5',
                      padding: '10px 0',
                      fontSize: 18,
                      outline: 'none',
                      fontFamily: 'Space Grotesk, sans-serif',
                      marginTop: 8,
                    }}
                  />
                </div>
              )}

              <button
                onClick={confirm}
                className="btn-solid"
                style={{
                  marginTop: 28,
                  width: '100%',
                  padding: '16px 28px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 10,
                }}
              >
                {thanks ? (
                  <><Check size={16} /> Thank you &mdash; you&apos;re a legend</>
                ) : (
                  <><Heart size={14} /> Send via UPI</>
                )}
              </button>

              <div
                className="mono"
                style={{
                  marginTop: 14,
                  fontSize: 11,
                  letterSpacing: '0.25em',
                  color: 'rgba(245,245,245,0.55)',
                  textTransform: 'uppercase',
                }}
              >
                UPI &middot; {upiInfo.id}
              </div>
            </div>

            {/* Flippable tip jar / QR */}
            <div
              className={`flip-card stack-mobile-border ${flipped ? 'flipped' : ''}`}
              style={{ borderLeft: '1px solid rgba(245,245,245,0.08)', paddingLeft: 40 }}
            >
              <div className="flip-inner">
                {/* FRONT: Tip jar */}
                <div className="flip-face" style={{ padding: '4px 4px 4px 0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
                    <div style={{ width: 44, height: 44, borderRadius: 999, background: '#f5f5f5', color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Coffee size={18} strokeWidth={1.8} />
                    </div>
                    <div>
                      <div className="mono" style={{ fontSize: 10, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.5)', textTransform: 'uppercase' }}>Tip jar</div>
                      <div style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 20, fontWeight: 500 }}>Buy Likith a coffee</div>
                    </div>
                  </div>

                  <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 12, color: 'rgba(245,245,245,0.7)', fontSize: 13.5, lineHeight: 1.6 }}>
                    <li style={{ display: 'flex', gap: 10 }}><Check size={16} style={{ marginTop: 2, color: '#f5f5f5' }} /> 100% of tips go into better gear, faster delivery.</li>
                    <li style={{ display: 'flex', gap: 10 }}><Check size={16} style={{ marginTop: 2, color: '#f5f5f5' }} /> Supporters get priority on future DMs.</li>
                    <li style={{ display: 'flex', gap: 10 }}><Check size={16} style={{ marginTop: 2, color: '#f5f5f5' }} /> Zero strings. Just pure appreciation.</li>
                  </ul>

                  <div style={{ marginTop: 24, padding: 16, border: '1px dashed rgba(245,245,245,0.15)', borderRadius: 10, color: 'rgba(245,245,245,0.55)', fontSize: 12.5, lineHeight: 1.6 }}>
                    Not into tipping? Sharing my work with one friend means just as much &mdash; thank you for being here.
                  </div>

                  <button
                    onClick={() => setFlipped(true)}
                    className="btn-ghost"
                    style={{ marginTop: 18, width: '100%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
                  >
                    <RotateCcw size={12} /> Show UPI QR scanner
                  </button>
                </div>

                {/* BACK: QR */}
                <div className="flip-face back" style={{ padding: '4px 4px 4px 0', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 12 }}>
                    <div className="mono" style={{ fontSize: 10, letterSpacing: '0.35em', color: 'rgba(245,245,245,0.5)', textTransform: 'uppercase' }}>
                      Scan to pay
                    </div>
                    <div style={{ width: 220, height: 220, borderRadius: 14, background: '#f5f5f5', padding: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <img src={upiInfo.qrImage} alt="UPI QR" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                    </div>
                    <div style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 18, fontWeight: 500 }}>{upiInfo.name}</div>
                    <div className="mono" style={{ fontSize: 11, letterSpacing: '0.25em', color: 'rgba(245,245,245,0.6)', textTransform: 'uppercase' }}>
                      {upiInfo.id}
                    </div>
                    <button onClick={() => setFlipped(false)} className="btn-ghost" style={{ marginTop: 6, display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                      <RotateCcw size={12} /> Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {tab === 'message' && (
          <div className="twocol" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: 36 }}>
            <div>
              <div className="mono" style={{ fontSize: 10, letterSpacing: '0.35em', color: 'rgba(245,245,245,0.5)', textTransform: 'uppercase', marginBottom: 18 }}>
                / For the trust-issue crew
              </div>
              <h3 style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 500, fontSize: 28, margin: 0, letterSpacing: '-0.01em', color: '#f5f5f5' }}>
                Talk first, tip later.
              </h3>
              <p style={{ color: 'rgba(245,245,245,0.65)', fontSize: 14, lineHeight: 1.7, marginTop: 14 }}>
                If you&apos;d rather verify it&apos;s really me before sending anything, slide into
                my DMs first. Once you&apos;re comfortable, you can drop the tip on UPI or crypto.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: '20px 0 0 0', display: 'flex', flexDirection: 'column', gap: 10, color: 'rgba(245,245,245,0.7)', fontSize: 13.5 }}>
                <li style={{ display: 'flex', gap: 10 }}><Check size={14} style={{ marginTop: 3, color: '#f5f5f5' }} /> No card, no pressure.</li>
                <li style={{ display: 'flex', gap: 10 }}><Check size={14} style={{ marginTop: 3, color: '#f5f5f5' }} /> I confirm I&apos;m human.</li>
                <li style={{ display: 'flex', gap: 10 }}><Check size={14} style={{ marginTop: 3, color: '#f5f5f5' }} /> Then send any way you like.</li>
              </ul>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, justifyContent: 'center' }}>
              <button onClick={() => window.open('https://instagram.com/liki9th', '_blank')} className="btn-solid" style={{ width: '100%', padding: '16px 24px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                <Instagram size={14} /> Message me on Instagram
              </button>
              <button onClick={goContact} className="btn-ghost" style={{ width: '100%', padding: '16px 24px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                <MessageSquare size={14} /> Open live chat / contact form
              </button>
            </div>
          </div>
        )}

        {tab === 'crypto' && (
          <div>
            <div className="mono" style={{ fontSize: 10, letterSpacing: '0.35em', color: 'rgba(245,245,245,0.5)', textTransform: 'uppercase', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 10 }}>
              <Bitcoin size={14} /> / Crypto wallets
            </div>
            <p style={{ color: 'rgba(245,245,245,0.65)', fontSize: 14, lineHeight: 1.7, maxWidth: 560, marginTop: 0, marginBottom: 24 }}>
              Send any amount on these networks. Make sure you pick the correct chain &mdash;
              wrong-chain transfers can&apos;t be recovered.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {cryptoWallets.map((w) => (
                <div
                  key={w.id}
                  style={{
                    padding: '20px 22px',
                    border: '1px solid rgba(245,245,245,0.1)',
                    borderRadius: 12,
                    background: 'rgba(10,10,10,0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 20,
                    flexWrap: 'wrap',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16, minWidth: 0, flex: 1 }}>
                    <div style={{ width: 44, height: 44, borderRadius: 12, background: '#f5f5f5', color: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Anton, sans-serif', fontSize: 18, letterSpacing: '0.05em', flexShrink: 0 }}>
                      {w.ticker}
                    </div>
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <div className="mono" style={{ fontSize: 10, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.5)', textTransform: 'uppercase' }}>
                        {w.name}
                      </div>
                      <div className="mono" style={{ fontSize: 13, color: '#f5f5f5', marginTop: 4, wordBreak: 'break-all', letterSpacing: '0.02em' }}>
                        {w.address}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => copyAddr(w.address, w.id)}
                    className="btn-ghost"
                    style={{ padding: '10px 18px', fontSize: 10, display: 'inline-flex', alignItems: 'center', gap: 8, flexShrink: 0 }}
                  >
                    {copiedAddr === w.id ? (<><Check size={12} /> Copied</>) : (<><Copy size={12} /> Copy</>)}
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
